import React, { Fragment } from "react";
import Bloghome from "../components/Bloghome";
import Floatingcall from "../components/floatingbutton/Floatingcall";
import Homeservices from "../components/Homeservices";
import Mainnew from "../components/Mainnew";
import Testinomials from "../components/Testinomials";
import WhyChooseUs from "../components/WhyChooseUs";
import { Helmet } from "react-helmet";
import HeroNew from "../components/HeroNew";
import Clients from "../components/Clients";
import HomeTestinomials from "../components/HomeTestinomials";

function Home() {
    return(
        <Fragment>
         <Helmet>
         <title>
          Best Cleaning Services in Noida | Professional House & Deep Cleaning Services
        </title>

        <meta
          name="description"
          content="Leading professional commercial cleaning company offering corporate cleaning services, office cleaning solutions, deep office cleaning & housekeeping manpower services."
        />

        <meta
          name="keywords"
          content="Professional Commercial Cleaning Services, Commercial Office Cleaning Services, Corporate Cleaning Services, Corporate Housekeeping Services, Housekeeping Manpower Services, Professional Commercial Cleaning Company, Office Cleaning Services, Deep Cleaning Services"
        />

        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta name="bingbot" content="index, follow" />
        <meta name="revisit-after" content="daily" />
        <meta name="allow-search" content="yes" />
        <meta name="copyright" content="Helper Ji" />

        {/* ===== CANONICAL ===== */}
        <link rel="canonical" href="https://www.helperji.in/" />

        {/* ===== OPEN GRAPH META ===== */}
        <meta
          property="og:title"
          content="Best Cleaning Services in Noida | Professional House & Deep Cleaning Services"
        />
        <meta
          property="og:description"
          content="Leading professional commercial cleaning company offering corporate cleaning services, office cleaning solutions, deep office cleaning & housekeeping manpower services."
        />
        <meta
          property="og:image"
          content="https://www.helperji.in/assets/img/Banner.jpg"
        />
        <meta property="og:site_name" content="Helper Ji" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.helperji.in/" />

        {/* ===== TWITTER META ===== */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@helperji_" />
        <meta name="twitter:creator" content="@helperji_" />
        <meta
          name="twitter:title"
          content="Best Cleaning Services in Noida | Professional House & Deep Cleaning Services"
        />
        <meta
          name="twitter:description"
          content="Leading professional commercial cleaning company offering corporate cleaning services, office cleaning solutions, deep office cleaning & housekeeping manpower services."
        />
        <meta
          name="twitter:image"
          content="https://www.helperji.in/assets/img/Banner.jpg"
        />

        {/* ===== ORGANIZATION SCHEMA ===== */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Helper Ji",
            "alternateName": "Helper Ji",
            "url": "https://www.helperji.in/",
            "logo": "https://www.helperji.in/assets/img/logo.png",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "7800780095",
              "contactType": "customer service",
              "areaServed": "IN",
              "availableLanguage": ["en", "Hindi"]
            },
            "sameAs": [
              "https://www.facebook.com/helperjiofficial",
              "https://x.com/helperji_",
              "https://www.instagram.com/helperji_official/"
            ]
          }
          `}
        </script>

        {/* ===== LOCAL BUSINESS SCHEMA ===== */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Helper Ji",
            "image": "https://www.helperji.in/assets/img/logo.png",
            "@id": "https://www.helperji.in/",
            "url": "https://www.helperji.in/",
            "telephone": "+917800780095",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "H-159, VDS Building, Suite No. 301A, Sector 63, Noida - 201301",
              "addressLocality": "Noida",
              "postalCode": "201301",
              "addressCountry": "IN"
            },
            "openingHoursSpecification": {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday"
              ],
              "opens": "09:00",
              "closes": "19:00"
            },
            "sameAs": [
              "https://www.facebook.com/helperjiofficial",
              "https://x.com/helperji_",
              "https://www.instagram.com/helperji_official/"
            ]
          }
          `}
        </script>

        {/* ===== WEBPAGE SCHEMA ===== */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "url": "https://www.helperji.in/",
            "name": "Best Cleaning Services in Noida | Professional House & Deep Cleaning Services",
            "description": "Leading professional commercial cleaning company offering corporate cleaning services, office cleaning solutions, deep office cleaning & housekeeping manpower services."
          }
          `}
        </script>
          <script type="text/javascript">
    {`
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "vuhgim22tp");
    `}
  </script>
         </Helmet>
        <Floatingcall />
        <HeroNew />
        <Mainnew />
        <Homeservices />
        <WhyChooseUs />
        <Testinomials />
        <Clients />
        <HomeTestinomials />
        <Bloghome />
    </Fragment>
)
}

export default Home;

